import { Customization } from '@eduvision/toolkit';

export const BottomAppBar: Customization['BottomAppBar'] = {
  loggedOutCategoryButtons: 'AUDIENCE',
  loggedOutCategoryIgnoreTypes: ['TEAM']
};
